// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__4qQTd","info":"Profile_info__RT6co","info-form":"Profile_info-form__GSH8E","password":"Profile_password__GzDUh"};